import React, { useEffect, useState } from 'react';
import defaultLogo from '../../images/logo.png'
import './Profile.css'
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import { guardarSiteConfig, obtenerLogoGuardado, obtenerNombreTiendaGuardado } from '../siteConfig';
export default function Profile() {
    const [contactos, setContactos] = useState([]);
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);
    const [storeName, setStoreName] = useState(() => obtenerNombreTiendaGuardado());

    useEffect(() => {
        cargarContacto();
        cargarLogo();

    }, []);

    const cargarLogo = async () => {
        try {
            const response = await fetch(`${baseURL}/configGet.php`);
            const data = await response.json();

            if (data.config) {
                guardarSiteConfig(data.config);
            }

            if (data.config?.logo) {
                setAppLogo(data.config.logo);
            }

            setStoreName(data.config?.nombreTienda?.trim() || '');
        } catch (error) {
            console.error('Error al cargar el logo del perfil:', error);
        }
    };


    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(Array.isArray(data.contacto) ? [...data.contacto].reverse()[0] || {} : {});

            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    return (
        <div className='profileContain'>
            <img src={appLogo} alt="Logo de la tienda" />
            <h2>{storeName || contactos.nombre}</h2>

            <div className='socials'>
                <a
                    href={contactos.instagram?.startsWith('http') ? contactos.instagram : `https://instagram.com/${contactos.instagram?.replace('@', '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className='fa fa-instagram'></i>
                </a>
                <a
                    href={`https://wa.me/${contactos.telefono?.replace(/\D/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className='fa fa-whatsapp'></i>
                </a>
                <a
                    href={contactos.facebook?.startsWith('http') ? contactos.facebook : `https://facebook.com/${contactos.facebook}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className='fa fa-facebook'></i>
                </a>
            </div>

            <div className='profileText'>
                <Anchor to={`/Productos`} >
                    Productos
                </Anchor>
                <Anchor to={`/mi-cuenta`}>
                    Mi cuenta
                </Anchor>
                <Anchor to={`/dashboard`} className='dashboardLinkProfile'>
                    Dashboard
                </Anchor>

            </div>
        </div>
    )
}
